var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureIconAttendee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4239_209)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#CFFAFE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4239_209)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53 56H44C43.7348 56 43.4804 55.8946 43.2929 55.7071C43.1054 55.5196 43 55.2652 43 55V53C43 52.7348 43.1054 52.4804 43.2929 52.2929C43.4804 52.1054 43.7348 52 44 52H53C53.2652 52 53.5196 52.1054 53.7071 52.2929C53.8946 52.4804 54 52.7348 54 53V55C54 55.2652 53.8946 55.5196 53.7071 55.7071C53.5196 55.8946 53.2652 56 53 56Z",
    fill: "#29D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 32H35C34.7348 32 34.4804 32.1054 34.2929 32.2929C34.1054 32.4804 34 32.7348 34 33V35C34 35.2652 34.1054 35.5196 34.2929 35.7071C34.4804 35.8946 34.7348 36 35 36H53C53.2652 36 53.5196 35.8946 53.7071 35.7071C53.8946 35.5196 54 35.2652 54 35V33C54 32.7348 53.8946 32.4804 53.7071 32.2929C53.5196 32.1054 53.2652 32 53 32Z",
    fill: "#29D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 38H35C34.7348 38 34.4804 38.1054 34.2929 38.2929C34.1054 38.4804 34 38.7348 34 39V49C34 49.2652 34.1054 49.5196 34.2929 49.7071C34.4804 49.8946 34.7348 50 35 50H53C53.2652 50 53.5196 49.8946 53.7071 49.7071C53.8946 49.5196 54 49.2652 54 49V39C54 38.7348 53.8946 38.4804 53.7071 38.2929C53.5196 38.1054 53.2652 38 53 38Z",
    fill: "#29D2D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4239_209",
    x: -8,
    y: 2,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.172549 0 0 0 0 0.25098 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4239_209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4239_209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4239_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconAttendee);
export default __webpack_public_path__ + "static/media/feature-icon-attendee.3938598aaf3ba06d436c4d6f834bbe5a.svg";
export { ForwardRef as ReactComponent };